import { Component, Input } from '@angular/core';
import { PhoneCallTypes } from 'voxloud-types/dist/models';

@Component({
  selector: 'app-call-type-chip',
  template: `
    <span class="vox-chip {{ chipClass }}">{{
      'events.company-call-history.details.fields.type.' + type | Translate
    }}</span>
  `,
})
export class CallTypeChipComponent {
  @Input() type: PhoneCallTypes;

  public PhoneCallTypes = PhoneCallTypes;

  public get chipClass(): string {
    switch (this.type) {
      case PhoneCallTypes.CLICK_TO_CALL:
        return 'vox-chip_purple-text';
      case PhoneCallTypes.FAX_CALL:
        return 'vox-chip_royal-blue-text';
      case PhoneCallTypes.PHONE_CALL:
        return 'vox-chip_bright-crimson-text';
      case PhoneCallTypes.WHATSAPP:
        return 'vox-chip_aquamarine-text';
    }
  }
}
